import {
  TypeGeneralLinkFields,
  TypeGeneralLinkSkeleton,
  TypeNavLinkListFields,
  TypeNavLinkPanelFields,
  TypeNavPromoItemFields,
  TypeNavPromoItemSkeleton,
} from "@customTypes/contentful";
import { MobileHistory } from "context/navigationContext";
import { Dispatch } from "react";

type Item = TypeNavLinkPanelFields &
  TypeNavLinkListFields &
  TypeNavLinkListFields &
  TypeGeneralLinkFields &
  TypeNavPromoItemFields & {
    label?: string;
    url?: string;
    fields?:
      | TypeNavLinkPanelFields
      | TypeNavLinkListFields
      | TypeGeneralLinkFields;
  };

export const getMenuLevel = (data: Item[]) => data?.map((item) => item?.fields);

export const handleItemClick = (
  mobileMenuHistory: MobileHistory,
  setMobileMenuHistory: Dispatch<React.SetStateAction<MobileHistory>>,
  menuItem: Item[],
  ownLink?: TypeGeneralLinkSkeleton,
  promoItems?: TypeNavPromoItemSkeleton[],
  promoCtAs?: TypeGeneralLinkSkeleton[]
) => {
  if (!menuItem) {
    setMobileMenuHistory([]);
    return;
  }
  let buff: MobileHistory = [...mobileMenuHistory];
  const currentItemIndex = buff.findIndex((item) => item.visibility === true);
  buff = buff.slice(0, currentItemIndex + 1);
  const level = getMenuLevel(menuItem);
  buff = buff.map((item) => {
    item.visibility = false;
    return item;
  });
  buff.push({
    items: level as (TypeNavLinkPanelFields | TypeNavLinkListFields)[],
    ownLink: ownLink,
    promoItems: promoItems,
    promoCtAs: promoCtAs,
    visibility: true,
    linkList: undefined,
  });
  setMobileMenuHistory(buff);
};

export const handleBackClick = (mobileMenuHistory, setMobileMenuHistory) => {
  const buff: MobileHistory = [...mobileMenuHistory];
  const currentItemIndex = buff.findIndex((item) => item.visibility === true);
  buff[currentItemIndex].visibility = false;
  buff[currentItemIndex - 1].visibility = true;
  setMobileMenuHistory(buff);
};
